import { datiStampaProposal, datiInvioEmail} from './sezioni/sezioniStampaProposal';

export const stampaProposal = {
  datiStampaProposal: datiStampaProposal,
  datiInvioEmail: datiInvioEmail,
};